<script setup>

import { getValue ,setValue } from './JsonHelper';

const props = defineProps({
    field: {
        type: Object,
        required: true
    },
    model: {
        type: Object,
        required: true
    }
});

</script>

<template>

    <div class="mb-3">

        <!-- Label -->
        <label
            v-if="props.field.label"
            class="form-label fw-bold"
        >
            {{ props.field.label }}
        </label>

        <!-- TEXT -->
        <input
            v-if="props.field.type === 'text'"
            class="form-control"
            :value="getValue(model, props.field.path)"
            @input="setValue(model, props.field.path, $event.target.value)"
        />

        <!-- NUMBER -->
        <input
            v-else-if="props.field.type === 'number'"
            type="number"
            class="form-control"
            :value="getValue(model, props.field.path)"
            @input="setValue(model, props.field.path, Number($event.target.value))"
        />

        <!-- TEXTAREA -->
        <textarea
            v-else-if="props.field.type === 'textarea'"
            rows="5"
            class="form-control"
            :value="getValue(model, props.field.path)"
            @input="setValue(model, props.field.path, $event.target.value)"
        />

        <!-- HTML -->
        <div
            v-else-if="props.field.type === 'html'"
            class="border rounded p-3"
            v-html="getValue(model, props.field.path)"
        />

        <!-- IMAGE -->
        <img
            v-else-if="props.field.type === 'image'"
            :src="getValue(model, props.field.path)"
            class="img-fluid rounded"
        />
        <!-- SELECT -->
        <select
            v-else-if="props.field.type === 'select'"
            class="form-select"
            :value="getValue(model, props.field.path)"
            @change="setValue(model, props.field.path, $event.target.value)"
        >
            <option
                v-for="option in props.field.options"
                :key="option.value"
                :value="option.value"
            >
                {{ option.text }}
            </option>
        </select>

        <!-- PARAMETERS -->
        <div
            v-else-if="props.field.type === 'parameter'"
            class="card p-3"
        >

            <div
                v-for="parameter in props.field.value"
                :key="parameter.id"
                class="row mb-2"
            >

                <div class="col-4 fw-bold">
                    {{ parameter.name }}
                </div>

                <div class="col-8">

                    <input
                        class="form-control"
                        :value="parameter.values?.join(', ')"
                        @input="parameter.values = $event.target.value
                        .split(',')
                        .map(x => x.trim())
                        .filter(Boolean)"
                    />

                </div>

            </div>

        </div>

        <!-- DESCRIPTION -->
        <div id="Id_GoTo_Preview"
            v-else-if="props.field.type === 'group'"
        >

            <div
                v-for="(section, sectionIndex) in props.field.value"
                :key="'section-' + sectionIndex"
                class="allegro-section row"
            >

                <div
                    v-for="(item, itemIndex) in section.items"
                    :key="'item-' + sectionIndex + '-' + itemIndex"
                    :class="section.items.length === 1
                        ? 'col-12'
                        : 'col-md-6'"
                >

                    <!-- TEXT -->
                    <div
                        v-if="item.type === 'TEXT'"
                        class="allegro-text"
                        v-html="item.content"
                    />

                    <!-- IMAGE -->
                    <div
                        v-else-if="item.type === 'IMAGE'"
                        class="allegro-image-wrapper"
                    >
                        <img
                            :src="item.url"
                            class="allegro-image"
                        >
                    </div>

                </div>

            </div>

        </div>

    </div>

</template>
